export default [
  {title: '设备SN',dataIndex: 'sn'},
  {title: '设备类型',dataIndex: 'deviceType',scopedSlots: { customRender: 'deviceType' }},
  {title: '店铺ID',dataIndex: 'storeId'},
  {title: '支付宝门店',dataIndex: 'fullName',scopedSlots: { customRender: 'fullName' }},
  {title: '最后请求时间',dataIndex: 'lastRequestTime'},
  {title: '操作',dataIndex: 'action', scopedSlots: { customRender: 'action'},width: 300}
]
